import { 
    CLEAR_GET_MOSTLY_FREQUENTLY_SERVICES,
    CLEAR_GET_PATIENT_PACKAGE_SERVICES,
    GET_ASSESSMENT_FORM_REPORTS_FAIL,
    GET_ASSESSMENT_FORM_REPORTS_LOADING,
    GET_ASSESSMENT_FORM_REPORTS_SUCCESS,
    GET_CLEAR_IPD_ADMITTED_PATIENTS,
    GET_CLEAR_IPD_WARDS,
    GET_CLEAR_MEDICATIONS,
    GET_DOCTOR_TIMESLOTS_FAIL,
    GET_DOCTOR_TIMESLOTS_LOADING,
    GET_DOCTOR_TIMESLOTS_SUCCESS,
    GET_FORM_FIELDS_FAIL, 
    GET_FORM_FIELDS_LOADING, 
    GET_FORM_FIELDS_SUCCESS,
    GET_IPD_ADMITTED_PATIENTS_FAIL,
    GET_IPD_ADMITTED_PATIENTS_LOADING,
    GET_IPD_ADMITTED_PATIENTS_SUCCESS,
    GET_IPD_WARDS_FAIL,
    GET_IPD_WARDS_LOADING,
    GET_IPD_WARDS_SUCCESS,
    GET_MEDICATIONS_FAIL,
    GET_MEDICATIONS_LOADING,
    GET_MEDICATIONS_SUCCESS,
    GET_MEDIC_ROUTES_FAIL,
    GET_MEDIC_ROUTES_LOADING,
    GET_MEDIC_ROUTES_SUCCESS,
    GET_MOSTLY_FREQUENTLY_SERVICES_FAIL,
    GET_MOSTLY_FREQUENTLY_SERVICES_LOADING,
    GET_MOSTLY_FREQUENTLY_SERVICES_SUCCESS,
    GET_PATIENT_PACKAGE_SERVICES_FAIL,
    GET_PATIENT_PACKAGE_SERVICES_LOADING,
    GET_PATIENT_PACKAGE_SERVICES_SUCCESS,
    POST_ASSESSMENT_FORM_FAIL,
    POST_ASSESSMENT_FORM_LOADING,
    POST_ASSESSMENT_FORM_SUCCESS,
    POST_COMPANY_ITEM_PREAUTHO_FAIL,
    POST_COMPANY_ITEM_PREAUTHO_LOADING,
    POST_COMPANY_ITEM_PREAUTHO_SUCCESS,} from "../Components/Constants/ActionTypes";


const Assessment = (state,{type,payload})=>{
    switch (type) {
        case GET_FORM_FIELDS_LOADING:
            return{
                ...state,
                getFormFields:{
                ...state.getFormFields,
                loading:true
              }
            };
        case GET_FORM_FIELDS_SUCCESS:
            return {
                ...state,
                getFormFields:{
                    ...state.getFormFields,
                    loading:false,
                    data:payload,
                }
            };
        case GET_FORM_FIELDS_FAIL:
            return{
                ...state,
                getFormFields:{
                    ...state.getFormFields,
                    loading:false,
                    error:payload,
                }
            };

        case POST_ASSESSMENT_FORM_LOADING:
            return{
                ...state,
                saveAssessmentForm:{
                ...state.saveAssessmentForm,
                loading:true
              }
            };
        case POST_ASSESSMENT_FORM_SUCCESS:
            return {
                ...state,
                saveAssessmentForm:{
                    ...state.saveAssessmentForm,
                    loading:false,
                    data:payload,
                }
            };
        case POST_ASSESSMENT_FORM_FAIL:
            return{
                ...state,
                saveAssessmentForm:{
                    ...state.saveAssessmentForm,
                    loading:false,
                    error:payload,
                }
            };

        case GET_ASSESSMENT_FORM_REPORTS_LOADING:
            return{
                ...state,
                AssessmentFormReports:{
                ...state.AssessmentFormReports,
                loading:true
                }
            };
        case GET_ASSESSMENT_FORM_REPORTS_SUCCESS:
            return {
                ...state,
                AssessmentFormReports:{
                    ...state.AssessmentFormReports,
                    loading:false,
                    data:payload,
                }
            };
        case GET_ASSESSMENT_FORM_REPORTS_FAIL:
            return{
                ...state,
                AssessmentFormReports:{
                    ...state.AssessmentFormReports,
                    loading:false,
                    error:payload,
                }
            };

        case POST_COMPANY_ITEM_PREAUTHO_LOADING:
            return{
                ...state,
                ItemPreAutho:{
                ...state.ItemPreAutho,
                loading:true
                }
            };
        case POST_COMPANY_ITEM_PREAUTHO_SUCCESS:
            return {
                ...state,
                ItemPreAutho:{
                    ...state.ItemPreAutho,
                    loading:false,
                    data:payload,
                }
            };
        case POST_COMPANY_ITEM_PREAUTHO_FAIL:
            return{
                ...state,
                ItemPreAutho:{
                    ...state.ItemPreAutho,
                    loading:false,
                    error:payload,
                }
            };

        case GET_MEDIC_ROUTES_LOADING:
            return{
                ...state,
                getMedicRoutes:{
                ...state.getMedicRoutes,
                loading:true
                }
            };
        case GET_MEDIC_ROUTES_SUCCESS:
            return {
                ...state,
                getMedicRoutes:{
                    ...state.getMedicRoutes,
                    loading:false,
                    data:payload,
                }
            };
        case GET_MEDIC_ROUTES_FAIL:
            return{
                ...state,
                getMedicRoutes:{
                    ...state.getMedicRoutes,
                    loading:false,
                    error:payload,
                }
            };
        case GET_MEDICATIONS_LOADING:
            return{
                ...state,
                requestMedic:{
                ...state.requestMedic,
                loading:true
                }
            };
        case GET_MEDICATIONS_SUCCESS:
            return {
                ...state,
                requestMedic:{
                    ...state.requestMedic,
                    loading:false,
                    data:payload,
                }
            };
        case GET_MEDICATIONS_FAIL:
            return{
                ...state,
                requestMedic:{
                    ...state.requestMedic,
                    loading:false,
                    error:payload,
                }
            };
        case GET_CLEAR_MEDICATIONS:
            return{
                ...state,
                requestMedic:{
                    data:[],
                    error:null,
                    loading:false,
                }
            };

        case GET_IPD_WARDS_LOADING:
            return{
                ...state,
                getIpdWards:{
                ...state.getIpdWards,
                loading:true
                }
            };
        case GET_IPD_WARDS_SUCCESS:
            return {
                ...state,
                getIpdWards:{
                    ...state.getIpdWards,
                    loading:false,
                    data:payload,
                }
            };
        case GET_IPD_WARDS_FAIL:
            return{
                ...state,
                getIpdWards:{
                    ...state.getIpdWards,
                    loading:false,
                    error:payload,
                }
            };
        case GET_CLEAR_IPD_WARDS:
            return{
                ...state,
                getIpdWards:{
                    data:[],
                    error:null,
                    loading:false,
                }
            };

        case GET_IPD_ADMITTED_PATIENTS_LOADING:
            return{
                ...state,
                getAdmittedPatient:{
                ...state.getAdmittedPatient,
                loading:true
                }
            };
        case GET_IPD_ADMITTED_PATIENTS_SUCCESS:
            return {
                ...state,
                getAdmittedPatient:{
                    ...state.getAdmittedPatient,
                    loading:false,
                    data:payload,
                }
            };
        case GET_IPD_ADMITTED_PATIENTS_FAIL:
            return{
                ...state,
                getAdmittedPatient:{
                    ...state.getAdmittedPatient,
                    loading:false,
                    error:payload,
                }
            };
        case GET_CLEAR_IPD_ADMITTED_PATIENTS:
            return{
                ...state,
                getAdmittedPatient:{
                    data:[],
                    error:null,
                    loading:false,
                }
            };
        case GET_MOSTLY_FREQUENTLY_SERVICES_LOADING:
            return{
                ...state,
                mostFrequentlyServices:{
                ...state.mostFrequentlyServices,
                loading:true
                }
            };
        case GET_MOSTLY_FREQUENTLY_SERVICES_SUCCESS:
            return {
                ...state,
                mostFrequentlyServices:{
                    ...state.mostFrequentlyServices,
                    loading:false,
                    data:payload,
                }
            };
        case GET_MOSTLY_FREQUENTLY_SERVICES_FAIL:
            return{
                ...state,
                mostFrequentlyServices:{
                    ...state.mostFrequentlyServices,
                    loading:false,
                    error:payload,
                }
            };
        case CLEAR_GET_MOSTLY_FREQUENTLY_SERVICES:
            return{
                ...state,
                mostFrequentlyServices:{
                    data:[],
                    error:null,
                    loading:false,
                }
            };
        case GET_DOCTOR_TIMESLOTS_LOADING:
            return{
                ...state,
                doctorTimeSlotsStates:{
                ...state.doctorTimeSlotsStates,
                loading:true
                }
            };
        case GET_DOCTOR_TIMESLOTS_SUCCESS:
            return {
                ...state,
                doctorTimeSlotsStates:{
                    ...state.doctorTimeSlotsStates,
                    loading:false,
                    data:payload,
                }
            };
        case GET_DOCTOR_TIMESLOTS_FAIL:
            return{
                ...state,
                doctorTimeSlotsStates:{
                    ...state.doctorTimeSlotsStates,
                    loading:false,
                    error:payload,
                }
            };
    case GET_PATIENT_PACKAGE_SERVICES_LOADING:
        return{
            ...state,
            patientPackageStates:{
            ...state.patientPackageStates,
            loading:true
            }
        };
    case GET_PATIENT_PACKAGE_SERVICES_SUCCESS:
        return {
            ...state,
            patientPackageStates:{
                ...state.patientPackageStates,
                loading:false,
                data:payload,
            }
        };
    case GET_PATIENT_PACKAGE_SERVICES_FAIL:
        return{
            ...state,
            patientPackageStates:{
                ...state.patientPackageStates,
                loading:false,
                error:payload,
            }
        };
    case CLEAR_GET_PATIENT_PACKAGE_SERVICES:
        return{
            ...state,
            patientPackageStates:{
                data:[],
                error:null,
                loading:false,
            }
        };
    }
}

export default Assessment;